<template>
  <div id="campaigns-component">
    <!-- table -->
    <div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-table :data="campaigns" :max-items="30" search pagination stripe>

            <div slot="header" class="flex-grow justify-left mb-4">
              <h3 class="mt-4 mb-2">Lista de campañas</h3>
              <vs-button size="small" @click.stop="isFormPrompt = true" icon="add_circle_outline"
                color='success'>
                Nueva campaña
              </vs-button>
            </div>

            <template slot="thead">
              <vs-th>Id</vs-th>
              <vs-th>Campaña</vs-th>
              <vs-th>Audiencia</vs-th>
              <vs-th>Plantilla</vs-th>
              <vs-th>Analítica</vs-th>
              <vs-th>AUDIENCIA</vs-th>
              <vs-th>F. de programación</vs-th>
              <vs-th>F. de envió</vs-th>
              <vs-th>F. de actualización</vs-th>
              <vs-th>F. de creación</vs-th>
              <vs-th>Acciones</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr v-for="(campaign, index) in data" :key="index">
                <vs-td>{{ campaign.id }}</vs-td>
                <vs-td><strong>{{ campaign.name }}</strong></vs-td>
                <vs-td>
                  {{ campaign.audience.id }} | {{ campaign.audience.description }}
                </vs-td>
                <vs-td>
                  {{ campaign.template.id }} | {{ campaign.template.name }}
                </vs-td>
                <vs-td class="text-center">
                  <vs-tooltip text="Solo consulta la información de los últimos 90 días"
                    v-if="isLessThan90Days(campaign.send_date)">
                    <i class="material-icons cursor-pointer" @click="openPostmark(campaign)">analytics</i>
                  </vs-tooltip>
                </vs-td>
                <vs-td class="text-center">
                  <span v-if="isMounted" class="bold">{{ campaign.audience_count ? `Total: ${campaign.audience_count}` : "" }}</span>
                  <div class="clickable-img success" @click.stop="countAudience(campaign.audience_id, campaign.id)">
                    <small><u>Consultar</u></small>
                  </div>
                </vs-td>
                <vs-td>
                  <span v-if="campaign.schedule_date !== null">
                    {{ campaign.schedule_date | fromNow }}
                  </span>
                  <span v-else>
                    Sin Programación
                  </span>
                </vs-td>
                <vs-td>
                  <span v-if="campaign.send_date !== null">
                    {{ campaign.send_date }}
                  </span>
                  <span v-else>
                    No se ha enviado
                  </span>
                </vs-td>
                <vs-td>{{ campaign.updated_at | humanize }}</vs-td>
                <vs-td>{{ campaign.created_at | humanize }}</vs-td>
                <vs-td>
                  <div v-if='campaign.send_date === null'>
                    <button type="button" class="btn btn-info btn-xs btn-block"
                      @click.stop="_launchTest(`${campaign.id}`)">
                      PROBAR
                      <feather-icon icon="PlayCircleIcon"
                        svgClasses="w-3 h-3 hover:text-danger stroke-current cursor-pointer" class="ml-2" />
                    </button>
                    <button type="button" class="btn btn-success btn-xs btn-block"
                      @click.stop="_launch(`${campaign.id}`)">
                      ENVIAR
                      <feather-icon icon="PlayCircleIcon"
                        svgClasses="w-3 h-3 hover:text-danger stroke-current cursor-pointer" class="ml-2" />
                    </button>

                    <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer"
                      class="ml-5 py-1" @click.stop="goToEdit(campaign.id)" />

                    <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer"
                      class="ml-5 py-1" @click.stop="_delete(`${campaign.id}`)" />
                  </div>
                  <div v-else>
                    <h6 class='text-success text-center'>
                      Enviada
                    </h6>
                  </div>
                </vs-td>
              </vs-tr>
            </template>

          </vs-table>
        </div>
      </div>

    </div>

    <!-- form -->
    <vs-popup v-if="isFormPrompt" title="Nueva campaña":active.sync="isFormPrompt">
      <NewCampaign
        @updated="getCampaigns"></NewCampaign>
    </vs-popup>

    <!-- edit -->
    <vs-popup v-if="isFormPromptEdit" title="Nueva campaña":active.sync="isFormPromptEdit">
      <EditCampaign
        :campaignId="campaignIdSelected"
        @updated="getCampaigns"></EditCampaign>
    </vs-popup>
  </div>
</template>

<script>
import {
  _humanizeDate,
  fromNowDate,
  humanizeDate
} from "@/filters/momentTzConvert";

import syntaxHighlight from "@mixins/syntaxHighlightJSON";
import NewCampaign from "./Form.vue";
import EditCampaign from "./Edit.vue"

export default {
  name: "Campaigns",
  mixins: [syntaxHighlight],
  components: {
    NewCampaign,
    EditCampaign
  },
  data: () => ({
    campaigns: [],
    modal: {
      show: false,
      title: 'Title preview: #',
      content: '',
    },
    isFormPrompt: false,
    isFormPromptEdit: false,
    campaignIdSelected: null,
    isMounted: false
  }),
  async mounted() {
    this.startLoading();
    await axios.get(`/api/app-http-services/services/notifications/email/campaigns`)
      .then(response => this.campaigns = response.data);
    this.stopLoading();
  },
  filters: {
    humanize: _humanizeDate,
    fromNow: humanizeDate,
    ago: fromNowDate
  },
  methods: {
    async getCampaigns() {
      this.showLoading(true);
      await axios.get(`/api/app-http-services/services/notifications/email/campaigns`)
      .then(response => this.campaigns = response.data);
      this.showLoading(false);

      this.isFormPrompt = false;
      this.isFormPromptEdit = false;
      this.campaignIdSelected = null;
    },
    isLessThan90Days(date) {
      if (date === null) {
        return false;
      }

      const today = new Date();
      const dateToCompare = new Date(date);
      const diffTime = Math.abs(today.getTime() - dateToCompare.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays < 90;
    },
    openPostmark(campaign) {
      const today = new Date().toISOString().slice(0, 10);
      const ninetyDayPass = new Date(new Date().setDate(new Date().getDate() - 90))
        .toISOString()
        .slice(0, 10);

      window.open(
        `https://account.postmarkapp.com/servers/5684121/streams/marketing/overview?from=${ninetyDayPass}&tag=${campaign.tag}&to=${today}`,
        '_blank'
      );
    },
    closeModal() {
      this.modal.show = false;
    },
    async _delete(campaign_id) {
      swal({
        title: `¿Esta seguro de eliminar la campaña #${campaign_id}?`,
        text: "* Esta acción no se puede revertir",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then(async (willDelete) => {
          if (willDelete) {
            this.startLoading();
            try {
              await axios.delete(
                `/api/app-http-services/services/notifications/email/campaigns/${campaign_id}`);
              this.getCampaigns();
            } catch (e) {
              if (e.response.status === 422) {
                await swal("Alerta", JSON.stringify(e.response.data), 'warning');
              }
              if (e.response.status === 500) {
                await swal("Error", "Hubo un error no controlado en el servicio de campañas", 'error');
              }
            } finally {
              this.stopLoading();
            }
          } else {
            swal("¡Acción cancelada!");
          }
        });
    },
    async _launch(campaign_id) {
      swal({
        title: `Confirmar envio de la campaña #${campaign_id}`,
        text: "* Confirma el envio de la campaña ",
        icon: "info",
        buttons: true,
        dangerMode: false,
      })
        .then(async (willDelete) => {
          if (willDelete) {
            this.startLoading();
            try {
              await axios.get(`/api/app-http-services/services/notifications/email/launch/${campaign_id}`);
              // this.modal.title = `Campaign preview: #${campaign_id}`;
            } catch (e) {
              if (e.response.status === 422) {
                await swal("Alerta", JSON.stringify(e.response.data), 'warning');
              }
              if (e.response.status === 500) {
                await swal("Error", "Hubo un error no controlado en el servicio de campañas", 'error');
              }
            } finally {
              location.reload();
              this.stopLoading();
            }
          } else {
            swal("¡Acción cancelada!");
          }
        });
    },
    async _launchTest(campaign_id) {
      this.startLoading();
      try {
        await axios.get(`/api/app-http-services/services/notifications/email/launch-test/${campaign_id}`);
      } catch (e) {
        if (e.response.status === 422) {
          await swal("Alerta", JSON.stringify(e.response.data), 'warning');
        }
        if (e.response.status === 500) {
          await swal("Error", "Hubo un error no controlado en el servicio de campañas", 'error');
        }
      } finally {
        this.stopLoading();
      }
    },
    async loadPreviewTemplate(email_marketing_template_id) {
      this.startLoading();
      try {
        await axios.get(
          `api/app-http-services/services/notifications/email/blades/templates/${email_marketing_template_id}`)
          .then(response => this.modal.content = response.data);
        this.modal.title = `Template preview: #${email_marketing_template_id}`;
      } catch (e) {
        this.stopLoading();
        if (e.response.status === 422) {
          await swal("Alerta", JSON.stringify(e.response.data), 'warning');
        }
        if (e.response.status === 500) {
          await swal("Error", "Hubo un error no controlado en el servicio de campañas", 'error');
        }
      } finally {
        this.modal.show = true;
        this.stopLoading();
      }
    },
    async loadPreviewAudience(audience_id) {
      this.startLoading();
      try {
        let countRows = 0;
        await axios.get(
          `/api/app-http-services/services/notifications/email/audiences/get-query/${audience_id}`)
          .then(response => {
            countRows = response.data.length;
            const showData = response.data.map(e => {
              return { 'Nombre: ': e.name, 'Correo: ': e.email }
            });
            this.modal.content = this.syntaxHighlight(showData);
          });
        this.modal.title = `Audience list: #${audience_id}, Total audience: ${countRows}`;
      } catch (error) {
        this.stopLoading();
        if (e.response.status === 422) {
          await swal("Alerta", JSON.stringify(e.response.data), 'warning');
        }
        if (e.response.status === 500) {
          await swal("Error", "Hubo un error no controlado en el servicio de campañas", 'error');
        }
      } finally {
        this.modal.show = true;
        this.stopLoading();
      }
    },
    goToEdit(campaignId) {
      this.campaignIdSelected = campaignId;
      this.isFormPromptEdit = true;
    },
    async countAudience(audience_id, campaign_id)
    {
      try {
        this.showLoading(true);
        this.isMounted = false;
        const res = await axios.get(`/api/app-http-services/services/notifications/email/audiences/get/audience-count/${audience_id}`);
        let campaignIndex = this.campaigns.findIndex(item => item.id == campaign_id);
        if(campaignIndex != -1) {
          this.campaigns[campaignIndex].audience_count  = res.data;
          this.isMounted = true;
        }
        this.showLoading(false);
      } catch (error) {
        this.showLoading(false);
        this.failedOperationNotif();
        console.log(error);
      }
    }
  },
}
</script>

<style></style>